import { render, staticRenderFns } from "./ku-navbar.vue?vue&type=template&id=31f56620&scoped=true"
import script from "./ku-navbar.vue?vue&type=script&lang=js"
export * from "./ku-navbar.vue?vue&type=script&lang=js"
import style0 from "./ku-navbar.vue?vue&type=style&index=0&id=31f56620&prod&lang=scss"
import style1 from "./ku-navbar.vue?vue&type=style&index=1&id=31f56620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f56620",
  null
  
)

export default component.exports